import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import supportStyle from "./support.module.css";
import { useSelector } from "react-redux";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;
const BASE_URL = `https://support2.${backend_api_base_url}`;

const SupportTicketDetail = () => {
  const { ticket_id } = useParams();
  const history = useHistory();
  const authToken = localStorage.getItem("token");
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [newRemark, setNewRemark] = useState("");
  const [saving, setSaving] = useState(false);



  const meData = useSelector((state) => state.auth.meData);
  console.log("am getting medata in the support detail page", meData)
  const tenant = meData?.tenant_info?.tenant;

  useEffect(() => {
    const fetchDetails = async () => {
      // if (!authToken || !ticket_id) return;
      if (!authToken || !ticket_id || !tenant) return;
      try {
        // const me = JSON.parse(localStorage.getItem("meData"));
        // const tenant = me.tenant_info.tenant;
        const res = await fetch(
          `${BASE_URL}/get?tenant=${tenant}&reference_id=${ticket_id}`,
          { headers: { Authorization: authToken } }
        );
        const data = await res.json();
        setTicket(data);
      } catch (err) {
        console.error("Error fetching ticket details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [ticket_id, authToken, tenant]);

  const updateTicket = async () => {
    if (!newRemark.trim()) return;
    setSaving(true);

    try {
      // const me = JSON.parse(localStorage.getItem("meData"));
      // const tenant = me.tenant_info.tenant;
      console.log("tenanttenanttenant", tenant);

      const res = await fetch(
        `${BASE_URL}/update?tenant=${tenant}&reference_id=${ticket_id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: authToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ remark: newRemark }),
        }
      );

      if (res.ok) {
        const updated = await res.json();
        setTicket(updated);
        setNewRemark("");
        setEditMode(false);
      } else {
        console.error("Failed to update ticket");
      }
    } catch (err) {
      console.error("Error updating ticket:", err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className={supportStyle.loading}>Loading ticket...</p>;
  if (!ticket) return <p className={supportStyle.error}>Ticket not found.</p>;

  const assignedInfo =
    ticket.assigned_to === "UNASSIGNED"
      ? "Unassigned"
      : ticket.assigned_user?.name || ticket.assigned_to;

  // Format issue type for display
  const getIssueTypeDisplay = (issueType) => {
    if (!issueType) return "Not specified";
    return issueType === "app" ? "App Related" : "Generic Issue";
  };

  return (
    <div className={supportStyle.detailPage}>
      <button
        onClick={() => history.push("/support")}
        className={supportStyle.backBtn}
      >
        ← Back to Tickets
      </button>

      <h2 className={supportStyle.heading}>Ticket Details</h2>

      <div className={supportStyle.ticketDetailBox}>
        <p className={supportStyle.infoRow}>
          <span className={supportStyle.label}>Reference ID:</span>
          <span className={supportStyle.value}>{ticket.reference_id}</span>
        </p>

        <p className={supportStyle.infoRow}>
          <span className={supportStyle.label}>Status:</span>
          <span className={supportStyle.value}>{ticket.status}</span>
        </p>

        <p className={supportStyle.infoRow}>
          <span className={supportStyle.label}>Issue Type:</span>
          <span className={supportStyle.value}>
            {getIssueTypeDisplay(ticket.issue_type)}
          </span>
        </p>

        {/* Show App ID only for app-related issues */}
        {ticket.issue_type === "app" && ticket.app_id && (
          <p className={supportStyle.infoRow}>
            <span className={supportStyle.label}>App ID:</span>
            <span className={supportStyle.value}>{ticket.app_id}</span>
          </p>
        )}

        <p className={supportStyle.infoRow}>
          <span className={supportStyle.label}>Assigned To:</span>
          <span
            className={`${supportStyle.value} ${assignedInfo === "Unassigned" ? supportStyle.unassigned : ""
              }`}
          >
            {assignedInfo}
          </span>
        </p>

        <p className={supportStyle.infoRow}>
          <span className={supportStyle.label}>Description:</span>
          <span className={supportStyle.value}>{ticket.description}</span>
        </p>

        <p className={supportStyle.infoRow}>
          <span className={supportStyle.label}>Images:</span>
        </p>
        <div className={supportStyle.imageGallery}>
          {(ticket.images || []).map((img, idx) => (
            <a
              key={idx}
              href={img}
              target="_blank"
              rel="noopener noreferrer"
              className={supportStyle.imageLink}
            >
              <img
                src={img}
                alt={`Ticket Image ${idx + 1}`}
                className={supportStyle.modalImage}
              />
            </a>
          ))}
        </div>

        <p style={{ margin: "2rem 0 0.5rem" }}>
          <strong>Remarks:</strong>
        </p>
        <ul className={supportStyle.remarksList}>
          {(ticket.remark || []).map((r, i) => (
            <li key={i} className={supportStyle.remarkItem}>{r}</li>
          ))}
          {(!ticket.remark || ticket.remark.length === 0) && (
            <li className={supportStyle.noRemarks}>No remarks yet</li>
          )}
        </ul>

        {editMode && (
          <textarea
            placeholder="Add remark"
            value={newRemark}
            onChange={(e) => setNewRemark(e.target.value)}
            className={supportStyle.remarkTextarea}
          />
        )}

        <div className={supportStyle.modalActions}>
          {editMode ? (
            <>
              <button
                onClick={updateTicket}
                className={supportStyle.saveBtn}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <span className={supportStyle.loader}></span> Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
              <button
                onClick={() => {
                  setEditMode(false);
                  setNewRemark("");
                }}
                className={supportStyle.cancelBtn}
                disabled={saving}
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              onClick={() => setEditMode(true)}
              className={supportStyle.editBtn}
            >
              Add Remark
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportTicketDetail;